import React, { useState, useEffect } from "react";
import { Card, Row, Col, Table, Spinner, Form, Button } from "react-bootstrap";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';

const Adminuser = () => {
    const [userId, setUserId] = useState(null);
    const [username, setUsername] = useState(null);
    const [patents, setPatents] = useState([]);
    const [publications, setPublications] = useState([]);
    const [mous, setMous] = useState([]);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [users, setUsers] = useState([]); // State for users
    const [selectedUser, setSelectedUser] = useState(""); // State for selected user

    // Fetch user list on mount
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/users`);
                const data = await response.json();
                setUsers(data);
            } catch (error) {
                console.error("Error fetching users:", error);
                setError("Error fetching user list");
            }
        };

        fetchUsers();
    }, []);

    useEffect(() => {
    const storedUser = sessionStorage.getItem('selectedUser');
    if (storedUser) {
        setSelectedUser(storedUser);

        const user = users.find((user) => user.username === storedUser);
        if (user) {
            setUserId(user.userId);
            setUsername(user.username);
            startCounting(user.userId, user.username); // Start counting with the selected user
        }
    }
}, [users]); // Dependency array ensures this runs when users are loaded
if (loading) {
    return (
        <div className="container" style={{
            position: 'absolute',  // Keep it absolute for positioning
            top: '40%',            // Position it 40% from the top of the page
            left: '50%',           // Horizontally center the container
            transform: 'translateX(-50%)', // Offset by 50% of its width to truly center
            display: 'flex',       // Flexbox for centering
            justifyContent: 'center', // Center content horizontally
            alignItems: 'center',  // Align content vertically
            zIndex: 1,             // Ensure it's on top of other content
            width: '100%',         // Full width of the page
            backgroundColor: 'transparent',  // Transparent background
            paddingTop: '20px',    // Optional padding from the top
        }}>

<div class="typewriter">
  <div class="slide"><i></i></div>
  <div class="paper"></div>
  <div class="keyboard"></div>
</div>

            {/* Keyframes for spinner rotation, text fade-in, and up effect */}
            <style>{`
               /* From Uiverse.io by Nawsome */ 
.typewriter {
--blue: #5C86FF;
--blue-dark: #275EFE;
--key: #fff;
--paper: #EEF0FD;
--text: #D3D4EC;
--tool: #FBC56C;
--duration: 3s;
position: relative;
-webkit-animation: bounce05 var(--duration) linear infinite;
animation: bounce05 var(--duration) linear infinite;
}

.typewriter .slide {
width: 92px;
height: 20px;
border-radius: 3px;
margin-left: 14px;
transform: translateX(14px);
background: linear-gradient(var(--blue), var(--blue-dark));
-webkit-animation: slide05 var(--duration) ease infinite;
animation: slide05 var(--duration) ease infinite;
}

.typewriter .slide:before, .typewriter .slide:after,
.typewriter .slide i:before {
content: "";
position: absolute;
background: var(--tool);
}

.typewriter .slide:before {
width: 2px;
height: 8px;
top: 6px;
left: 100%;
}

.typewriter .slide:after {
left: 94px;
top: 3px;
height: 14px;
width: 6px;
border-radius: 3px;
}

.typewriter .slide i {
display: block;
position: absolute;
right: 100%;
width: 6px;
height: 4px;
top: 4px;
background: var(--tool);
}

.typewriter .slide i:before {
right: 100%;
top: -2px;
width: 4px;
border-radius: 2px;
height: 14px;
}

.typewriter .paper {
position: absolute;
left: 24px;
top: -26px;
width: 40px;
height: 46px;
border-radius: 5px;
background: var(--paper);
transform: translateY(46px);
-webkit-animation: paper05 var(--duration) linear infinite;
animation: paper05 var(--duration) linear infinite;
}

.typewriter .paper:before {
content: "";
position: absolute;
left: 6px;
right: 6px;
top: 7px;
border-radius: 2px;
height: 4px;
transform: scaleY(0.8);
background: var(--text);
box-shadow: 0 12px 0 var(--text), 0 24px 0 var(--text), 0 36px 0 var(--text);
}

.typewriter .keyboard {
width: 120px;
height: 56px;
margin-top: -10px;
z-index: 1;
position: relative;
}

.typewriter .keyboard:before, .typewriter .keyboard:after {
content: "";
position: absolute;
}

.typewriter .keyboard:before {
top: 0;
left: 0;
right: 0;
bottom: 0;
border-radius: 7px;
background: linear-gradient(135deg, var(--blue), var(--blue-dark));
transform: perspective(10px) rotateX(2deg);
transform-origin: 50% 100%;
}

.typewriter .keyboard:after {
left: 2px;
top: 25px;
width: 11px;
height: 4px;
border-radius: 2px;
box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
-webkit-animation: keyboard05 var(--duration) linear infinite;
animation: keyboard05 var(--duration) linear infinite;
}

@keyframes bounce05 {
85%, 92%, 100% {
  transform: translateY(0);
}

89% {
  transform: translateY(-4px);
}

95% {
  transform: translateY(2px);
}
}

@keyframes slide05 {
5% {
  transform: translateX(14px);
}

15%, 30% {
  transform: translateX(6px);
}

40%, 55% {
  transform: translateX(0);
}

65%, 70% {
  transform: translateX(-4px);
}

80%, 89% {
  transform: translateX(-12px);
}

100% {
  transform: translateX(14px);
}
}

@keyframes paper05 {
5% {
  transform: translateY(46px);
}

20%, 30% {
  transform: translateY(34px);
}

40%, 55% {
  transform: translateY(22px);
}

65%, 70% {
  transform: translateY(10px);
}

80%, 85% {
  transform: translateY(0);
}

92%, 100% {
  transform: translateY(46px);
}
}

@keyframes keyboard05 {
5%, 12%, 21%, 30%, 39%, 48%, 57%, 66%, 75%, 84% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}

9% {
  box-shadow: 15px 2px 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}

18% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 2px 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}

27% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 12px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}

36% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 12px 0 var(--key), 60px 12px 0 var(--key), 68px 12px 0 var(--key), 83px 10px 0 var(--key);
}

45% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 2px 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}

54% {
  box-shadow: 15px 0 0 var(--key), 30px 2px 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}

63% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 12px 0 var(--key);
}

72% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 2px 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 10px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}

81% {
  box-shadow: 15px 0 0 var(--key), 30px 0 0 var(--key), 45px 0 0 var(--key), 60px 0 0 var(--key), 75px 0 0 var(--key), 90px 0 0 var(--key), 22px 10px 0 var(--key), 37px 12px 0 var(--key), 52px 10px 0 var(--key), 60px 10px 0 var(--key), 68px 10px 0 var(--key), 83px 10px 0 var(--key);
}
}
            `}</style>
        </div>
    );
}

    const handleSelectChange = (e) => {
        const selectedUser = e.target.value;
        setSelectedUser(selectedUser);
    
        // Store selected user in sessionStorage
        sessionStorage.setItem('selectedUser', selectedUser);
    
        const user = users.find((user) => user.username === selectedUser);
        if (user) {
            setUserId(user.userId);
            setUsername(user.username);
            startCounting(user.userId, user.username); // Start counting with the selected user
            window.location.reload();
        }
    };
    

    const startCounting = async (storedUserId, storedUsername) => {

        try {
            setLoading(true);

            const [patentData, publicationData, mouData,projectData] = await Promise.all([
                fetchPaginatedData(`${process.env.REACT_APP_API_BASE_URL}/api/patents`),
                fetchPaginatedData(`${process.env.REACT_APP_API_BASE_URL}/api/publications/userr/${storedUserId}`),
                fetchPaginatedData(`${process.env.REACT_APP_API_BASE_URL}/api/mous`),
                fetchProjects(storedUserId)
            ]);
            // Filter and set the respective data for patents, publications, MOUs, and projects
            const userPatents = patentData.filter((patent) => {
                const inventors = patent.inventors?.split(",").map((name) => name.trim()) || [];
                return inventors.includes(storedUserId);
            });
            setPatents(userPatents);

            const userPublications = publicationData.filter((publication) => {
              // Check if the publication is claimed by the user
              if (publication.claimedBy === storedUserId) {
                  return true;
              }
              return false;
          });
          
          setPublications(userPublications);
          
            
           

            const userMous = mouData.filter((mou) => {
                const storedUserIds = storedUserId.split(",").map((id) => id.trim());
                const mouPartners = mou.sonaPartners?.split(",").map((partner) => partner.trim()) || [];
                return mouPartners.some((partner) => storedUserIds.includes(partner));
            });
            setMous(userMous);

          

        } catch (error) {
            setError("Error fetching data");
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchProjects = async (storedUserId) => {
      try {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/projects/user/${storedUserId}`);
  
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
  
          const projectData = await response.json();
          console.log("Fetched Project Data:", projectData);
          setProjects(projectData)
          return projectData;
      } catch (error) {
          console.error("Error fetching project data:", error);
          return [];
      }
  };
  
    const fetchPaginatedData = async (url) => {
        let allData = [];
        let page = 0;
        let totalPages = 1;

        try {
            do {
                const response = await fetch(`${url}?page=${page}&size=1000`);
                const data = await response.json();
                const resourceKey = Object.keys(data._embedded || {}).find((key) => url.includes(key));
                if (resourceKey) {
                    allData = [...allData, ...data._embedded[resourceKey]];
                } else {
                    console.warn("No embedded resource found for URL:", url);
                    break;
                }
                totalPages = data.page?.totalPages || 1;
                page++;
            } while (page < totalPages);
        } catch (err) {
            console.error("Error fetching paginated data:", err);
        }

        return allData;
    };

    const iconStyle = { fontSize: '2rem' };

    if (loading) {
      return (
          <div className="container" style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              position: 'relative',
              zIndex: 1,
              overflow: 'hidden'
          }}>
              {/* Background overlay with blur effect */}
              <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  backdropFilter: 'blur(5px)',
                  zIndex: -1
              }}></div>
  
              {/* Loader and text */}
              <div style={{
                  textAlign: 'center',
                  zIndex: 2,
                  animation: 'fadeInUp 1.5s ease-in-out'
              }}>
                  <Spinner
                      animation="border"
                      variant="primary"
                      style={{
                          width: '50px',
                          height: '50px',
                          borderWidth: '5px',
                          animation: 'spin 2s linear infinite'
                      }}
                  />
                  <p style={{
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#5a5a5a',
                      marginTop: '20px',
                      animation: 'fadeInText 2s ease-out forwards'
                  }}>
                      Please Wait...
                  </p>
              </div>
  
              {/* Keyframes for spinner rotation, text fade-in, and up effect */}
              <style>{`
                  @keyframes spin {
                      0% { transform: rotate(0deg); }
                      100% { transform: rotate(360deg); }
                  }
                  @keyframes fadeInText {
                      0% { opacity: 0; transform: translateY(10px); }
                      100% { opacity: 1; transform: translateY(0); }
                  }
                  @keyframes fadeInUp {
                      0% { opacity: 0; transform: translateY(20px); }
                      100% { opacity: 1; transform: translateY(0); }
                  }
              `}</style>
          </div>
      );
  }
  

    if (error) {
        return (
            <div className="container mt-5">
                <p>{error}</p>
            </div>
        );
    }

        const handleEditMou = (mouId) => {
      window.location.href=`/AddMou/${mouId}`;
     // Redirect to the EditMou page with the mouId
  };
  const handleDeleteMou = async (mouId) => {
    try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/mous/${mouId}`);
        setMous(mous.filter(mou => mou.mouId !== mouId)); // Remove the deleted MOU from the state
        toast.success("MOU deleted successfully!");
    } catch (error) {
        console.error("Error deleting MOU:", error);
        toast.error("Failed to delete MOU. Please try again later.");
    }
};

  const handleEditProject = (projId) => {
        window.location.href=`/editproject/${projId}`;
    
};
const handleEditPatent = (projId) => {
  window.location.href=`/edit-patent/${projId}`;

};

const handleDeletePatent = async (patentId) => {
    try {
      // Send a DELETE request to the server with mouId and projectId
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/patents/${patentId}`);
      toast.success('Patent deleted successfully!');
    } catch (error) {
      console.error('Error deleting Project:', error);
      toast.error('Failed to delete Patent Please try again later.');
    }
  };

// Functions to handle actions
const handleAddOutcome = (mouId) => {
    sessionStorage.setItem("selectedMouId", mouId);
    console.log(`MOU ID ${mouId} stored for adding outcome.`);
    window.location.href="/MouOutcome"
    // Navigate to the outcome addition page or open the form
  };
  
  const handleViewOutcome = (mouId) => {
    sessionStorage.setItem("selectedMouId", mouId);
    console.log(`MOU ID ${mouId} stored for viewing outcomes.`);
    // Navigate to the outcome viewing page or fetch outcomes
    window.location.href="/MouOutcomes"
  };

    return (
        <div className="container mt-5">
            <ToastContainer/>
            <Card className="shadow-sm">
                <Card.Body>
                    <Card.Title className="d-flex flex-column flex-md-row align-items-center text-start">
                        <h3>Choose Faculty</h3>
                        <Form className="d-flex">
    <Form.Control
        as="input"
        list="userList"
        value={selectedUser}
        placeholder="Select User"
        onChange={handleSelectChange}
        style={{ width: "250px" }}
        required
    />
 <datalist
                id="userList"
                style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
                    backgroundColor: "#fff",
                    padding: "5px 0",
                    width: "250px", // Ensure it matches the width of the input field
                }}
            >
                {users.map((user) => (
                    <option
                        key={user.userId}
                        value={user.username} // The value to be submitted
                        style={{
                            padding: "8px 12px",
                            fontSize: "14px",
                            fontWeight: "600",
                            backgroundColor: "#fff",
                            color: "#333",
                            borderBottom: "1px solid #f1f1f1",
                            cursor: "pointer",
                            textAlign: "left",
                            transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = "#f9f9f9")}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
                    >
                        {`${user.username} (ID: ${user.userId})`}
                    </option>
                ))}
            </datalist>


</Form>
                    </Card.Title>
                    <hr />

                    <h3 className="m-4" style={{ fontWeight: 'lighter', color: '#5a5a5a' }}>User Contributions</h3>

                    {userId ? (
                        <>
                            <Row className="mb-4">
                                <Col xs={12} sm={6} md={3} className="d-flex justify-content-center mb-3 mb-md-0 text-black">
                                    <button className="btn btn" style={pat} disabled>
                                        <i className="fas fa-gavel text-black" style={iconStyle}></i>
                                        Patents
                                        <div className="mt-1" style={countStyle}>{patents.length}</div>
                                    </button>
                                </Col>
                                <Col xs={12} sm={6} md={3} className="d-flex justify-content-center mb-3 mb-md-0 text-black">
                                    <button className="btn btn-success text-black" style={pu} disabled>
                                        <i className="fas fa-book text-black" style={iconStyle}></i>
                                        Publications
                                        <div className="mt-1" style={countStyle}>{publications.length}</div>
                                    </button>
                                </Col>
                                <Col xs={12} sm={6} md={3} className="d-flex justify-content-center mb-3 mb-md-0">
                                    <button className="btn btn-info" style={mo} disabled>
                                        <i className="fas fa-handshake" style={iconStyle}></i>
                                        MOUs
                                        <div className="mt-1" style={countStyle}>{mous.length}</div>
                                    </button>
                                </Col>
                                <Col xs={12} sm={6} md={3} className="d-flex justify-content-center text-black">
                                    <button className="btn btn-info" style={pr} disabled>
                                        <i className="fas fa-tasks" style={iconStyle}></i>
                                        Projects
                                        <div className="mt-1" style={countStyle}>{projects.length}</div>
                                    </button>
                                </Col>
                            </Row>

                            <h4 className="mt-4">Patents Details</h4>
<DataTable
  data={patents}
  columns={["Patent ID", "Title", "Action"]}
  keys={[
    "id",
    "title",
    (item) => (
      <div>
        <button
          className="btn btn-primary btn-sm"
          style={{ cursor: "pointer", marginRight: "5px" }}
          onClick={() => handleEditPatent(item.id)}
        >
          Edit
        </button>
        <button
          className="btn btn-danger btn-sm"
          style={{ cursor: "pointer" }}
          onClick={() => handleDeletePatent(item.id)}
        >
          Delete
        </button>
      </div>
    ),
  ]}
/>



                           <h4 className="mt-4">Publications Details</h4>
                            <DataTable data={publications} columns={["Publication ID", "Title", "Journal/Conference"]} keys={["id", "title", (item) => item.journal || item.conference]} />
      
                <h4 className="mt-4">MOU Details</h4>
                <DataTable
  data={mous}
  columns={["MOU ID", "Title", "MOU Type", "Date Signed", "Validity", "Action"]}
  keys={[
    "mouId",
    "title",
    "mou_type",
    (item) => new Date(item.dateOfSign).toLocaleDateString(),
    (item) => (item.dateOfEnd ? new Date(item.dateOfEnd).toLocaleDateString() : "N/A"),
    (item) => (
      <div className="d-flex gap-2">
       <h6
  className="p-2 text-center border rounded text-light"
  style={{
    cursor: "pointer",
    width: "60px",
    textAlign: "center",
    backgroundColor: "var(--bs-primary)",
    marginRight: "5px",
    marginTop: "10px",
    transition: "background-color 0.3s, color 0.3s",
  }}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#004085";
    e.target.style.color = "white";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "var(--bs-primary)";
    e.target.style.color = "white";
  }}
  onClick={() => handleEditMou(item.mouId)}
>
  Edit Mou
</h6>

<h6
  className="p-2 text-center border rounded text-light"
  style={{
    cursor: "pointer",
    width: "90px",
    textAlign: "center",
    backgroundColor: "var(--bs-primary)",
    marginRight: "5px",
    marginTop: "10px",
    transition: "background-color 0.3s, color 0.3s",
  }}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#004085";
    e.target.style.color = "white";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "var(--bs-primary)";
    e.target.style.color = "white";
  }}
  onClick={() => handleDeleteMou(item.mouId)}
>
  Delete Mou
</h6>

<h6
  className="p-2 text-center border rounded text-light"
  style={{
    cursor: "pointer",
    width: "90px",
    textAlign: "center",
    backgroundColor: "var(--bs-primary)",
    marginRight: "5px",
    marginTop: "10px",
    transition: "background-color 0.3s, color 0.3s",
  }}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#004085";
    e.target.style.color = "white";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "var(--bs-primary)";
    e.target.style.color = "white";
  }}
  onClick={() => handleAddOutcome(item.mouId)}
>
  Add Outcome
</h6>
<h6
  className="p-2 text-center border rounded text-light"
  style={{
    cursor: "pointer",
    width: "90px",
    textAlign: "center",
    backgroundColor: "var(--bs-primary)",
    marginRight: "5px",
    marginTop: "10px",
    transition: "background-color 0.3s, color 0.3s",
  }}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#004085";
    e.target.style.color = "white";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "var(--bs-primary)";
    e.target.style.color = "white";
  }}
  onClick={() => handleViewOutcome(item.mouId)}
>
  View Outcome
</h6>

      </div>
    ),
  ]}
/>



      
<h4 className="mt-4">Projects Details</h4>
<DataTable
    data={projects}
    columns={["Project ID", "Title", "Summary", "Start Date", "End Date", "Action"]}
    keys={[
        "projId",
        "projTitle",
        "projSummary",
        (item) => new Date(item.projStartDate).toLocaleDateString(),
        (item) => (item.projEndDate ? new Date(item.projEndDate).toLocaleDateString() : "N/A"),
        (item) => (
            <button
                className="btn btn-primary btn-sm"
                onClick={() => handleEditProject(item.projId)}
            >
                Edit
            </button>
        )
    ]}
/>

              </>
                    ) : (
                        <p>No user selected.</p>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};


const mo = { width: '8rem', height: '8rem', fontSize: '1rem', fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',backgroundColor:'#FFFF00' };
const pat = { width: '8rem', height: '8rem', fontSize: '1rem', fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' ,backgroundColor:'#259BB9' };
const pr = { width: '8rem', height: '8rem', fontSize: '1rem', fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',backgroundColor:'#DE8191' };
const pu = { width: '8rem', height: '8rem', fontSize: '1rem', fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',backgroundColor:'#0DEAC9' };
const buttonStyle = { width: '8rem', height: '8rem', fontSize: '1rem', fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' };
const countStyle = { fontSize: '1.5rem' };

const DataTable = ({ data, columns, keys }) => (
    <Table striped bordered hover responsive>
        <thead>
            <tr>
                {columns.map((col, index) => (
                    <th key={index}>{col}</th>
                ))}
            </tr>
        </thead>
        <tbody>
            {data.length > 0 ? (
                data.map((item, index) => (
                    <tr key={index}>
                        {keys.map((key, i) => (
                            <td key={i}>{typeof key === "function" ? key(item) : item[key]}</td>
                        ))}
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan={columns.length}>No data found</td>
                </tr>
            )}
        </tbody>
    </Table>
);

export default Adminuser;
